
export default {
  data() {
    return {
      en: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE'],
    }
  },
  props: {
   
  },
  methods: {
    assignColumnIds(tableId, startingCellId) {
        const table = document.getElementById(tableId);
        const rows = table.getElementsByTagName("tr");        
        for (let i = 0; i< rows.length; i++) {
          const row = rows[i];
          const cells = row.getElementsByTagName("td");
          for (let k = 0; k < cells.length; k++) {
            let cell = cells[k]            
            cell.setAttribute("id", `${this.en[k]}${(startingCellId + i)}`)
            
          }
            
        }
      },
  },
};
